export default __webpack_public_path__ + "static/media/TaleTrek.235ed26f.png";